function Home(props) {
    return(
        <div class="main">
            <h1>Home</h1>
            <p>Hi, I'm Bradley. I'm a software engineer with a background in life science 🧬, sustainability 🌎, and visual arts 🕺. I'm currently working on becoming an even stronger full stack developer 🖥 and finding Boston's best phở 🍜.</p>
            <div class="center">
            <div class="twocolumn">
            <h2>My Top 10 Technical Skills</h2>
            <img class="hobbyPic"src="https://bradleymather.com/wp-content/uploads/2022/08/pexels-lee-campbell-89724-scaled.jpg" alt="tech skills"/>
            <ul>
                <li>JavaScript</li>
                <li>Node.js</li>
                <li>React.js</li>
                <li>Express.js</li>
                <li>Python/Django</li>
                <li>Ruby on Rails</li>
                <li>SQL & NoSQL</li>
                <li>APIs</li>
                <li>HTML</li>
                <li>CSS</li>
            </ul>
            </div>
            <div class="twocolumn">
            <h2>My Top 10 Soft Skills</h2>
            <img class="hobbyPic"src="https://bradleymather.com/wp-content/uploads/2022/08/pexels-mikhail-nilov-8730283-scaled.jpg" alt="tech skills"/>
            <ul>
                <li>Leadership</li>
                <li>Organization</li>
                <li>Critical Thinking & Problem Solving</li>
                <li>Professionalism</li>
                <li>Drive to Learn and Grow</li>
                <li>Above and Beyond Customer Service</li>
                <li>Teaching & Training</li>
                <li>Staff Management</li>
                <li>Loyalty & Trust</li>
                <li>Flexibility</li>
            </ul>
            </div>
            </div>
            <br/>
            <h2>Full Resume</h2>
            <iframe src="https://bradleymather.com/wp-content/uploads/2022/10/Bradley-R-Mather-ATS-Resume-10-22.pdf" height="1122px" width="100%" title="Resume"></iframe>
        </div>
    )
}
export default Home